import type {
  GraphQLResponse,
  RequestParameters,
  Variables,
} from 'relay-runtime';

type GraphQLResponseBody = {
  data?: Record<string, unknown> | null;
  errors?: ReadonlyArray<{ message?: string }>;
};

export async function fetchGraphQL(
  request: RequestParameters,
  variables: Variables,
): Promise<GraphQLResponse> {
  const response = await fetch(process.env.GRAPHQL_ENDPOINT || '/graphql', {
    method: 'POST',
    // Mesmo domínio (proxy /graphql do Pages): o cookie de sessão HttpOnly vai junto.
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: request.text, variables }),
  });

  const json = (await response.json()) as GraphQLResponseBody;
  if (!response.ok || json.errors?.length) {
    throw new Error(json.errors?.[0]?.message || `GraphQL request failed: ${response.status}`);
  }

  return json as GraphQLResponse;
}
